export default {"src":"/_next/static/media/yellow-ellipse.93f1c882.svg","height":14,"width":13,"blurWidth":0,"blurHeight":0};